import { render, staticRenderFns } from "./NewCustomer.vue?vue&type=template&id=797c352c&scoped=true"
import script from "./NewCustomer.vue?vue&type=script&lang=js"
export * from "./NewCustomer.vue?vue&type=script&lang=js"
import style0 from "./NewCustomer.vue?vue&type=style&index=0&id=797c352c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797c352c",
  null
  
)

export default component.exports